/* eslint-disable react/jsx-filename-extension */
import { h, Fragment } from 'preact'
import { useSize } from '@utils/dom'
import modelTypes from '@constants/modelTypes'
import useSSR from '@core/hooks/useSSR'

export default function HeaderLinks({
	headerLinks,
	wishlistQuantity,
	cartQuantity,
	showSearchIcon,
	showMenuIcon,
	search,
	SearchComponent,
	storePhone,
	customerLinks,
}) {
	const { isDesktop, isMobile } = useSize()
	const { routes } = useSSR([modelTypes.routes])
	const isCartPage = window.location.pathname === '/cart'
	const phoneTextMobile = window.INITIAL_RESOURCES['navbar.call.mobile']

	const { isAuthenticated, shoppingCartEnabled, wishlistEnabled } = headerLinks

	return (
		<div className="headerLinks header-links" style={{ position: 'relative' }}>
			{!isDesktop && (
				<div className="header-link nav-main-phone">
					<div className="nav-main-phone__icon">
						<svg xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 -960 960 960" width={24}>
							<path d="M777.614-140.001q-113.076 0-227.191-52.577-114.115-52.577-209.691-148.346-95.577-95.769-148.154-209.691-52.577-113.923-52.577-226.999 0-18.165 12-30.275t30-12.11h130.46q15.154 0 26.731 9.885 11.577 9.885 14.73 24.423L376.845-668q2.385 16.385-1 28.154-3.384 11.769-12.154 19.769l-92.384 89.923q22.308 40.846 50.962 77.269 28.654 36.424 62.038 69.578 32.924 32.923 70.001 61.154 37.077 28.231 80.077 52.538l89.769-90.538q9.385-9.769 22.731-13.692 13.346-3.923 27.731-1.923l111.075 22.615q15.154 4 24.731 15.461 9.577 11.462 9.577 26.001v129.69q0 18-12.11 30t-30.275 12ZM242.923-586.922l71.385-68.308q1.923-1.539 2.5-4.231.577-2.693-.192-5l-17.385-89.385q-.769-3.077-2.692-4.615-1.923-1.539-5-1.539H206q-2.307 0-3.846 1.539-1.539 1.538-1.539 3.846 3.077 41 13.423 83.308 10.347 42.308 28.885 84.385Zm347.999 345.691q39.77 18.539 82.962 28.347 43.193 9.807 80.731 11.653 2.308 0 3.846-1.538 1.539-1.539 1.539-3.847v-84.153q0-3.077-1.539-5.001-1.538-1.923-4.615-2.692l-84-17.077q-2.307-.769-4.038-.192-1.731.577-3.654 2.5l-71.232 72ZM242.923-586.922Zm347.999 345.691Z" />
						</svg>
					</div>

					<a href={`tel:${storePhone}`} className="nav-main-phone__content">
						<span className="nav-main-phone__title">{phoneTextMobile}</span>
						<span className="nav-main-phone__number">{storePhone}</span>
					</a>
				</div>
			)}

			{showSearchIcon && (
				<div className="header-link menu-item--toggle-search" data-drawer-toggle="search">
					<svg
						width="24"
						height="24"
						fill="none"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M10 2.5a7.5 7.5 0 0 1 5.964 12.048l4.743 4.745a1 1 0 0 1-1.32 1.497l-.094-.083-4.745-4.743A7.5 7.5 0 1 1 10 2.5Zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z"
							fill="#000000"
						/>
					</svg>
				</div>
			)}

			<div
				className="header-link menu-item--toggle-menu --mobile-only"
				data-drawer-toggle="menu"
				data-drawer-icon-active="menu"
				data-drawer-icon-inactive="close"
			>
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M2.75254 17.9997H21.2525C21.6667 17.9997 22.0025 18.3355 22.0025 18.7497C22.0025 19.1294 21.7204 19.4432 21.3543 19.4928L21.2525 19.4997H2.75254C2.33832 19.4997 2.00254 19.1639 2.00254 18.7497C2.00254 18.37 2.28469 18.0562 2.65077 18.0065L2.75254 17.9997H21.2525H2.75254ZM2.75254 11.5027H21.2525C21.6667 11.5027 22.0025 11.8385 22.0025 12.2527C22.0025 12.6324 21.7204 12.9462 21.3543 12.9959L21.2525 13.0027H2.75254C2.33832 13.0027 2.00254 12.6669 2.00254 12.2527C2.00254 11.873 2.28469 11.5592 2.65077 11.5095L2.75254 11.5027H21.2525H2.75254ZM2.75168 5.00293H21.2517C21.6659 5.00293 22.0017 5.33872 22.0017 5.75293C22.0017 6.13263 21.7195 6.44642 21.3535 6.49608L21.2517 6.50293H2.75168C2.33746 6.50293 2.00168 6.16714 2.00168 5.75293C2.00168 5.37323 2.28383 5.05944 2.64991 5.00978L2.75168 5.00293H21.2517H2.75168Z"
						fill="#fff"
					/>
				</svg>

				<span style={{ color: 'white' }}>Meny</span>
			</div>

			{/* {wishlistEnabled && (
                <Fragment>
                    <div
                        id="menu-item--wishlist"
                        className="header-link"
                        data-drawer-toggle="wishlist"
                    >
                        <div className="link">
                            <svg
                                width={48}
                                height={48}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12.8199 5.57912L11.9992 6.40163L11.1759 5.57838C9.07688 3.47931 5.67361 3.47931
                                    3.57455 5.57838C1.47548 7.67744 1.47548 11.0807 3.57455 13.1798L11.4699 21.0751C11.7628
                                    21.368 12.2377 21.368 12.5306 21.0751L20.432 13.1783C22.5264 11.0723 22.53 7.67857
                                    20.4306 5.57912C18.3277 3.47623 14.9228 3.47623 12.8199 5.57912ZM19.3684 12.1206L12.0002
                                    19.4842L4.63521 12.1191C3.12192 10.6058 3.12192 8.15232 4.63521 6.63904C6.14849 5.12575
                                    8.602 5.12575 10.1153 6.63904L11.4727 7.99648C11.7706 8.29435 12.2553 8.28854 12.5459
                                    7.98363L13.8806 6.63978C15.3977 5.12268 17.8528 5.12268 19.3699 6.63978C20.8836 8.15343
                                    20.881 10.5997 19.3684 12.1206Z"
                                    fill="#212121"
                                />
                            </svg>

                            <span className="item-quantity">
                                {wishlistQuantity}
                            </span>
                        </div>
                        <span>Önskelistan</span>
                    </div>
                </Fragment>
            )} */}

			{!isDesktop && (
				<div className="header-link auth-item">
					{!isAuthenticated ? (
						<a href={routes.customer.login}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
								<path fill="none" d="M0 0h24v24H0z" />
								<path d="M10 11V8l5 4-5 4v-3H1v-2h9zm-7.542 4h2.124A8.003 8.003 0 0 0 20 12 8 8 0 0 0 4.582 9H2.458C3.732 4.943 7.522 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.478 0-8.268-2.943-9.542-7z" />
							</svg>
							<span>Logga in</span>
						</a>
					) : (
						<a href={routes.customer.info}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
								<path fill="none" d="M0 0h24v24H0z" />
								<path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-4.987-3.744A7.966 7.966 0 0 0 12 20c1.97 0 3.773-.712 5.167-1.892A6.979 6.979 0 0 0 12.16 16a6.981 6.981 0 0 0-5.147 2.256zM5.616 16.82A8.975 8.975 0 0 1 12.16 14a8.972 8.972 0 0 1 6.362 2.634 8 8 0 1 0-12.906.187zM12 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
							</svg>
							<span>Profil</span>
						</a>
					)}
				</div>
			)}

			{shoppingCartEnabled && isDesktop && (
				<div
					id="menu-item--cart"
					className="header-link --desktop"
					data-drawer-toggle="cart"
					style={{
						pointerEvents: isCartPage ? 'none' : 'all',
						opacity: isCartPage ? '0.5' : '1',
						position: isCartPage ? 'relative' : 'initial',
					}}
				>
					<span>{cartQuantity}st artiklar</span>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
						<path fill="none" d="M0 0h24v24H0z" />
						<path
							d="M4 6.414L.757 3.172l1.415-1.415L5.414 5h15.242a1 1 0 0 1 .958 1.287l-2.4 8a1 1 0 0 1-.958.713H6v2h11v2H5a1 1 0 0 1-1-1V6.414zM6 7v6h11.512l1.8-6H6zm-.5 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
							fill="rgba(255,255,255,1)"
						/>
					</svg>
				</div>
			)}

			{shoppingCartEnabled && !isDesktop && (
				<div
					id="menu-item--cart"
					className="header-link cart-item"
					data-drawer-toggle="cart"
					style={{ position: 'relative', padding: 0 }}
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
						<path fill="none" d="M0 0h24v24H0z" />
						<path
							d="M4 6.414L.757 3.172l1.415-1.415L5.414 5h15.242a1 1 0 0 1 .958 1.287l-2.4 8a1 1 0 0 1-.958.713H6v2h11v2H5a1 1 0 0 1-1-1V6.414zM6 7v6h11.512l1.8-6H6zm-.5 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
							fill="rgba(255,255,255,1)"
						/>
					</svg>

					<span>Kassan</span>
					<span className="--indicator">{cartQuantity}</span>
				</div>
			)}
		</div>
	)
}
